import { createSlice } from '@reduxjs/toolkit';
import { ProductCompletionSheetsListStateType } from 'src/types/productCompletionSheetsList';

const initialState: ProductCompletionSheetsListStateType = {
    data: null,
    loading: false,
    error: false,
};
export const productCompletionSheetsListSlice = createSlice({
    name: 'productCompletionSheetsList',
    initialState,
    reducers: {
        getProductCompletionSheetsListFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getProductCompletionSheetsListFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getProductCompletionSheetsListFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getProductCompletionSheetsListFetch,
    getProductCompletionSheetsListFetchSuccess,
    getProductCompletionSheetsListFetchFailure,
} = productCompletionSheetsListSlice.actions;

export default productCompletionSheetsListSlice.reducer;
